import { render, staticRenderFns } from "./inbound-query.vue?vue&type=template&id=c4dfd104&scoped=true"
import script from "./inbound-query.vue?vue&type=script&lang=ts"
export * from "./inbound-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dfd104",
  null
  
)

export default component.exports